import Medusa from "@medusajs/js-sdk"

const MEDUSA_BACKEND_URL = import.meta.env.VITE_MEDUSA_BACKEND_URL as string | undefined
const DEV_MEDUSA_BACKEND_URL = "http://localhost:9000"
const MEDUSA_PROXY_PATH = "/medusa"
const isBrowser = typeof window !== "undefined"

const serverBaseUrl =
  MEDUSA_BACKEND_URL || (import.meta.env.DEV ? DEV_MEDUSA_BACKEND_URL : undefined)

if (!MEDUSA_BACKEND_URL && import.meta.env.DEV && !isBrowser) {
  console.warn(
    "[+Bake Cafe] VITE_MEDUSA_BACKEND_URL is not set. " +
      `Falling back to ${DEV_MEDUSA_BACKEND_URL} in development.`
  )
}

const baseUrl = isBrowser
  ? `${window.location.origin}${MEDUSA_PROXY_PATH}`
  : serverBaseUrl

if (!baseUrl) {
  throw new Error(
    "VITE_MEDUSA_BACKEND_URL environment variable is required. " +
      "Set it in your .env file to point to your Medusa backend."
  )
}

export const sdk = new Medusa({
  baseUrl,
  debug: import.meta.env.DEV,
  publishableKey: import.meta.env.VITE_MEDUSA_PUBLISHABLE_KEY,
  auth: {
    type: "session",
  }
})
